import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {JourneyPage} from './journey/journey-page.component';
import {JourneyDiaryPage} from './journey-diary/journey-diary-page.component';
import {TaskPage} from './task/task.page';
import {JourneyStagePage} from './journey-stage/journey-stage-page.component';

const routes: Routes = [
    {
        path: '',
        component: JourneyPage
    },
    {
        path: ':step',
        component: JourneyPage
    },
    {
        path: 'link/:template_id/step/:step',
        component: JourneyPage
    },
    {
        path: 'stage/:template_id/:stage_id',
        component: JourneyStagePage
    },
    {
        path: 'diary/:pDelegateId',
        component: JourneyDiaryPage
    },
    {
        path: 'task/:task_id',
        component: TaskPage
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class JourneyRoutingModule {
}
